/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Legal Immigration RAG API
 * Backend API for Legal Immigration RAG system
## Error codes

Every non-2xx response uses the flat shape
`{"code": "...", "message": "...", "retryable": bool, "request_id": "..."}`

| Code | HTTP | Retryable | Meaning |
|---|---|---|---|
| `UNAUTHENTICATED` | 401 | No | Caller is not authenticated |
| `FORBIDDEN` | 403 | No | Caller lacks permission |
| `NOT_FOUND` | 404 | No | Resource does not exist |
| `METHOD_NOT_ALLOWED` | 405 | No | HTTP method not valid for this endpoint |
| `VALIDATION_FAILED` | 400/422 | No | Request body / query param invalid |
| `CONFLICT` | 409 | No | Resource-state conflict |
| `RATE_LIMITED` | 429 | **Yes** | Too many requests — back off and retry |
| `MODEL_ERROR` | 5xx | **Yes** | LLM call failed transiently |
| `RETRIEVAL_ERROR` | 5xx | **Yes** | Vector/keyword search failed transiently |
| `INTERNAL_ERROR` | 5xx | **Yes** | Transient infrastructure error |
| `SESSION_LIMIT_REACHED` | 409 | No | User has hit the 10-session cap |
| `NO_MESSAGE_AVAILABLE` | 422 | No | No message available for title generation |
| `TITLE_GENERATION_TIMEOUT` | 503 | **Yes** | LLM timed out generating a title |
| `TITLE_GENERATION_FAILED` | 503 | **Yes** | LLM failed generating a title |
| `EMAIL_DISPOSABLE` | 403 | No | Sign-up blocked: throwaway email provider |
| `EMAIL_DOMAIN_NOT_ALLOWED` | 403 | No | Sign-up blocked: domain denylisted or not on the allowlist |
| `EMAIL_SUBADDRESS_NOT_ALLOWED` | 403 | No | Sign-up blocked: `+tag` alias — use the plain address |
| `EMAIL_INVALID` | 403 | No | Sign-up blocked: address is not usable |

 * OpenAPI spec version: 0.0.1
 */
import { customFetch } from '../mutator/custom-fetch'
export interface BugReportRequest {
  /**
   * @minLength 1
   * @maxLength 2000
   */
  description: string
  app_version?: string | null
  platform?: string | null
}

export interface BugReportResponse {
  id: string
  created_at: string
}

export type ChatRequestEffort = (typeof ChatRequestEffort)[keyof typeof ChatRequestEffort]

export const ChatRequestEffort = {
  auto: 'auto',
  quick: 'quick',
  standard: 'standard',
  deep: 'deep',
} as const

export interface ChatRequest {
  session_id?: string | null
  /** @minLength 1 */
  message: string
  effort?: ChatRequestEffort
}

export type ChatResponseEffort = (typeof ChatResponseEffort)[keyof typeof ChatResponseEffort]

export const ChatResponseEffort = {
  quick: 'quick',
  standard: 'standard',
  deep: 'deep',
} as const

export interface CitationModel {
  source: string
  section: string
  url: string
  excerpt: string
  deep_link?: string | null
}

export interface RationaleModel {
  chunk_id: string
  explanation: string
  /**
   * @minimum 0
   * @maximum 1
   */
  confidence: number
}

export interface ChatResponse {
  session_id: string
  query: string
  rewritten_query: string
  answer: string
  citations: CitationModel[]
  rationales: RationaleModel[]
  is_grounded: boolean
  /**
   * @minimum 0
   * @maximum 1
   */
  confidence: number
  follow_ups?: string[]
  is_high_stake?: boolean
  high_stake_topic?: 'refusal' | 'appeal' | 'deportation' | 'asylum' | 'settlement' | null
  grounding_statement?: string | null
  is_uncertain?: boolean
  effort?: ChatResponseEffort
  question_cost?: number
}

export type CheckoutSessionRequestPlanCode =
  (typeof CheckoutSessionRequestPlanCode)[keyof typeof CheckoutSessionRequestPlanCode]

export const CheckoutSessionRequestPlanCode = {
  member_monthly: 'member_monthly',
  member_annual: 'member_annual',
  application_pass: 'application_pass',
} as const

export interface CheckoutSessionRequest {
  plan_code: CheckoutSessionRequestPlanCode
  success_path?: string
  cancel_path?: string
  idempotency_key?: string | null
}

export interface CheckoutSessionResponse {
  url: string
}

export type MessageModelRole = (typeof MessageModelRole)[keyof typeof MessageModelRole]

export const MessageModelRole = {
  user: 'user',
  assistant: 'assistant',
} as const

export interface MessageModel {
  id: string
  role: MessageModelRole
  content: string
  citations: CitationModel[]
  rationales: RationaleModel[]
  timestamp: string
  is_grounded?: boolean | null
  confidence?: number | null
  is_high_stake?: boolean
  high_stake_topic?: 'refusal' | 'appeal' | 'deportation' | 'asylum' | 'settlement' | null
  grounding_statement?: string | null
  is_uncertain?: boolean
  superseded_by?: string | null
}

export interface ConversationResponse {
  session_id: string
  user_id?: string | null
  messages: MessageModel[]
  created_at: string
  last_active: string
}

/**
 * Response schema for the disclaimer / terms endpoint.
 */
export interface DisclaimerResponse {
  disclaimer: string
  terms: string
}

export interface EditMessageRequest {
  content: string
}

/**
 * Premium feature gates, derived server-side from tier/status/payment state.

Lets web clients render gating without duplicating tier rules. All three
currently track the same "paid tier with usable access" boolean; they stay
separate fields so the contract survives them diverging later.
 */
export interface FeatureEntitlements {
  full_history?: boolean
  conversation_export?: boolean
  share_links?: boolean
}

export type FeedbackRequestRating =
  (typeof FeedbackRequestRating)[keyof typeof FeedbackRequestRating]

export const FeedbackRequestRating = {
  up: 'up',
  down: 'down',
} as const

export interface FeedbackRequest {
  rating: FeedbackRequestRating
  comment?: string | null
}

export type FeedbackResponseRating =
  (typeof FeedbackResponseRating)[keyof typeof FeedbackResponseRating]

export const FeedbackResponseRating = {
  up: 'up',
  down: 'down',
} as const

export interface FeedbackResponse {
  id: string
  message_id: string
  user_id: string
  rating: FeedbackResponseRating
  comment: string | null
  created_at: string
}

export interface ValidationError {
  loc: (string | number)[]
  msg: string
  type: string
}

export interface HTTPValidationError {
  detail?: ValidationError[]
}

export interface MagicLinkRequest {
  /**
   * @maxLength 254
   * @pattern ^[^@\s]+@[^@\s]+\.[^@\s]+$
   */
  email: string
}

/**
 * Deliberately contentless.

The response is identical whether or not the address belongs to an existing
account, so it cannot be used to enumerate registered users.
 */
export interface MagicLinkResponse {
  sent?: boolean
}

export type MembershipResponseTier =
  (typeof MembershipResponseTier)[keyof typeof MembershipResponseTier]

export const MembershipResponseTier = {
  free: 'free',
  member_monthly: 'member_monthly',
  member_annual: 'member_annual',
  application_pass: 'application_pass',
} as const

export type MembershipResponseStatus =
  (typeof MembershipResponseStatus)[keyof typeof MembershipResponseStatus]

export const MembershipResponseStatus = {
  trialing: 'trialing',
  active: 'active',
  canceling: 'canceling',
  past_due: 'past_due',
  expired: 'expired',
} as const

export interface MembershipResponse {
  tier: MembershipResponseTier
  status: MembershipResponseStatus
  started_at: string
  expires_at?: string | null
  trial_ends_at?: string | null
  current_period_start?: string | null
  current_period_end?: string | null
  cancel_at_period_end?: boolean
  stripe_subscription_status?: string | null
  question_limit?: number | null
  questions_used?: number
  questions_remaining?: number | null
  deep_turn_limit?: number | null
  deep_turns_used?: number
  deep_turns_remaining?: number | null
  period_label?: string | null
  usage_period_start?: string | null
  usage_period_end?: string | null
  payment_required?: boolean
  /** Premium gates derived from tier/status/payment state — always in sync.

  Computed (not stored) so any ``MembershipResponse`` — including ones built in
  tests or copied via ``model_copy`` — exposes features consistent with its
  tier/status, with no caller obliged to recompute them. */
  readonly features: FeatureEntitlements
}

export interface PortalSessionRequest {
  return_path?: string
}

export interface PortalSessionResponse {
  url: string
}

export interface PromptResponse {
  id: string
  text: string
}

export interface RenameSessionRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  title: string
}

export interface SessionModel {
  session_id: string
  title: string
  pinned: boolean
  pinned_at?: string | null
  created_at: string
  last_message_at?: string | null
  deleted_at?: string | null
}

export interface SessionResponse {
  session_id: string
}

export interface ShareSessionResponse {
  url: string
  token: string
}

export type SharedMessageModelRole =
  (typeof SharedMessageModelRole)[keyof typeof SharedMessageModelRole]

export const SharedMessageModelRole = {
  user: 'user',
  assistant: 'assistant',
} as const

export interface SharedMessageModel {
  role: SharedMessageModelRole
  content: string
  citations: CitationModel[]
  timestamp: string
}

export interface SharedSessionResponse {
  messages: SharedMessageModel[]
  created_at: string
}

export interface TitleSuggestRequest {
  /** The user's first message. If omitted, falls back to DB lookup (slower). */
  message?: string | null
}

export interface TitleSuggestResponse {
  /** A 2–6 word, ≤60 char session title */
  title: string
}

export interface UpdateDisplayNameRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  display_name: string
}

export interface UserResponse {
  id: string
  firebase_uid: string
  email?: string | null
  display_name?: string | null
  avatar_url?: string | null
  membership?: MembershipResponse | null
  created_at: string
}

export type ListSessionsApiSessionsGetParams = {
  search?: string
}

export type ListSessionsAliasApiSessionsListGetParams = {
  search?: string
}

export type StripeWebhookApiStripeWebhookPost200 = { [key: string]: boolean }

export type sendMagicLinkApiAuthMagicLinkPostResponse200 = {
  data: MagicLinkResponse
  status: 200
}

export type sendMagicLinkApiAuthMagicLinkPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type sendMagicLinkApiAuthMagicLinkPostResponseSuccess =
  sendMagicLinkApiAuthMagicLinkPostResponse200 & {
    headers: Headers
  }
export type sendMagicLinkApiAuthMagicLinkPostResponseError =
  sendMagicLinkApiAuthMagicLinkPostResponse422 & {
    headers: Headers
  }

export type sendMagicLinkApiAuthMagicLinkPostResponse =
  | sendMagicLinkApiAuthMagicLinkPostResponseSuccess
  | sendMagicLinkApiAuthMagicLinkPostResponseError

export const getSendMagicLinkApiAuthMagicLinkPostUrl = () => {
  return `/api/auth/magic-link`
}

/**
 * Email a passwordless sign-in link to the given address.

Unauthenticated by necessity — the caller is signing in. Rate limited per IP
because an open endpoint that sends mail on demand is otherwise a free relay
for mailbombing a third party.
 * @summary Send Magic Link
 */
export const sendMagicLinkApiAuthMagicLinkPost = async (
  magicLinkRequest: MagicLinkRequest,
  options?: RequestInit
): Promise<sendMagicLinkApiAuthMagicLinkPostResponse> => {
  return customFetch<sendMagicLinkApiAuthMagicLinkPostResponse>(
    getSendMagicLinkApiAuthMagicLinkPostUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(magicLinkRequest),
    }
  )
}

export type chatApiChatPostResponse200 = {
  data: ChatResponse
  status: 200
}

export type chatApiChatPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type chatApiChatPostResponseSuccess = chatApiChatPostResponse200 & {
  headers: Headers
}
export type chatApiChatPostResponseError = chatApiChatPostResponse422 & {
  headers: Headers
}

export type chatApiChatPostResponse = chatApiChatPostResponseSuccess | chatApiChatPostResponseError

export const getChatApiChatPostUrl = () => {
  return `/api/chat/`
}

/**
 * Handle chat requests tied to a specific session.
 * @summary Chat
 */
export const chatApiChatPost = async (
  chatRequest: ChatRequest,
  options?: RequestInit
): Promise<chatApiChatPostResponse> => {
  return customFetch<chatApiChatPostResponse>(getChatApiChatPostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(chatRequest),
  })
}

export type chatStreamApiChatStreamPostResponse200 = {
  data: unknown
  status: 200
}

export type chatStreamApiChatStreamPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type chatStreamApiChatStreamPostResponseSuccess = chatStreamApiChatStreamPostResponse200 & {
  headers: Headers
}
export type chatStreamApiChatStreamPostResponseError = chatStreamApiChatStreamPostResponse422 & {
  headers: Headers
}

export type chatStreamApiChatStreamPostResponse =
  | chatStreamApiChatStreamPostResponseSuccess
  | chatStreamApiChatStreamPostResponseError

export const getChatStreamApiChatStreamPostUrl = () => {
  return `/api/chat/stream`
}

/**
 * Stream chat responses as Server-Sent Events.

Auth and session ownership are enforced before any bytes are written so
unauthenticated or unauthorized requests get a normal HTTP 401/403/404
response. Once headers have flushed, mid-stream failures are surfaced as
``event: error`` rather than swapped status codes.
 * @summary Chat Stream
 */
export const chatStreamApiChatStreamPost = async (
  chatRequest: ChatRequest,
  options?: RequestInit
): Promise<chatStreamApiChatStreamPostResponse> => {
  return customFetch<chatStreamApiChatStreamPostResponse>(getChatStreamApiChatStreamPostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(chatRequest),
  })
}

export type createSessionApiSessionsPostResponse200 = {
  data: SessionResponse
  status: 200
}

export type createSessionApiSessionsPostResponseSuccess =
  createSessionApiSessionsPostResponse200 & {
    headers: Headers
  }
export type createSessionApiSessionsPostResponse = createSessionApiSessionsPostResponseSuccess

export const getCreateSessionApiSessionsPostUrl = () => {
  return `/api/sessions/`
}

/**
 * Create a new conversation session owned by the authenticated user.
 * @summary Create Session
 */
export const createSessionApiSessionsPost = async (
  options?: RequestInit
): Promise<createSessionApiSessionsPostResponse> => {
  return customFetch<createSessionApiSessionsPostResponse>(getCreateSessionApiSessionsPostUrl(), {
    ...options,
    method: 'POST',
  })
}

export type listSessionsApiSessionsGetResponse200 = {
  data: SessionModel[]
  status: 200
}

export type listSessionsApiSessionsGetResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listSessionsApiSessionsGetResponseSuccess = listSessionsApiSessionsGetResponse200 & {
  headers: Headers
}
export type listSessionsApiSessionsGetResponseError = listSessionsApiSessionsGetResponse422 & {
  headers: Headers
}

export type listSessionsApiSessionsGetResponse =
  | listSessionsApiSessionsGetResponseSuccess
  | listSessionsApiSessionsGetResponseError

export const getListSessionsApiSessionsGetUrl = (params?: ListSessionsApiSessionsGetParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0 ? `/api/sessions/?${stringifiedParams}` : `/api/sessions/`
}

/**
 * List all sessions for the current user, optionally filtered by title.
Pinned sessions always appear first.

Free members only see sessions active within the last ``FREE_HISTORY_DAYS`` days;
paid members see all history. The filter is applied server-side so direct session
IDs follow the same rule (see ``get_session``).
 * @summary List Sessions
 */
export const listSessionsApiSessionsGet = async (
  params?: ListSessionsApiSessionsGetParams,
  options?: RequestInit
): Promise<listSessionsApiSessionsGetResponse> => {
  return customFetch<listSessionsApiSessionsGetResponse>(getListSessionsApiSessionsGetUrl(params), {
    ...options,
    method: 'GET',
  })
}

export type listSessionsAliasApiSessionsListGetResponse200 = {
  data: SessionModel[]
  status: 200
}

export type listSessionsAliasApiSessionsListGetResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listSessionsAliasApiSessionsListGetResponseSuccess =
  listSessionsAliasApiSessionsListGetResponse200 & {
    headers: Headers
  }
export type listSessionsAliasApiSessionsListGetResponseError =
  listSessionsAliasApiSessionsListGetResponse422 & {
    headers: Headers
  }

export type listSessionsAliasApiSessionsListGetResponse =
  | listSessionsAliasApiSessionsListGetResponseSuccess
  | listSessionsAliasApiSessionsListGetResponseError

export const getListSessionsAliasApiSessionsListGetUrl = (
  params?: ListSessionsAliasApiSessionsListGetParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/sessions/list?${stringifiedParams}`
    : `/api/sessions/list`
}

/**
 * Backward-compatible alias for GET /api/sessions.
 * @summary List Sessions Alias
 */
export const listSessionsAliasApiSessionsListGet = async (
  params?: ListSessionsAliasApiSessionsListGetParams,
  options?: RequestInit
): Promise<listSessionsAliasApiSessionsListGetResponse> => {
  return customFetch<listSessionsAliasApiSessionsListGetResponse>(
    getListSessionsAliasApiSessionsListGetUrl(params),
    {
      ...options,
      method: 'GET',
    }
  )
}

export type getSessionApiSessionsSessionIdGetResponse200 = {
  data: ConversationResponse
  status: 200
}

export type getSessionApiSessionsSessionIdGetResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getSessionApiSessionsSessionIdGetResponseSuccess =
  getSessionApiSessionsSessionIdGetResponse200 & {
    headers: Headers
  }
export type getSessionApiSessionsSessionIdGetResponseError =
  getSessionApiSessionsSessionIdGetResponse422 & {
    headers: Headers
  }

export type getSessionApiSessionsSessionIdGetResponse =
  | getSessionApiSessionsSessionIdGetResponseSuccess
  | getSessionApiSessionsSessionIdGetResponseError

export const getGetSessionApiSessionsSessionIdGetUrl = (sessionId: string) => {
  return `/api/sessions/${sessionId}`
}

/**
 * Fetch a single session with its messages.

Subject to the same retention rule as the listing: a Free member requesting a
session older than ``FREE_HISTORY_DAYS`` gets 404, so direct IDs can't bypass it.
 * @summary Get Session
 */
export const getSessionApiSessionsSessionIdGet = async (
  sessionId: string,
  options?: RequestInit
): Promise<getSessionApiSessionsSessionIdGetResponse> => {
  return customFetch<getSessionApiSessionsSessionIdGetResponse>(
    getGetSessionApiSessionsSessionIdGetUrl(sessionId),
    {
      ...options,
      method: 'GET',
    }
  )
}

export type renameSessionApiSessionsSessionIdPatchResponse200 = {
  data: SessionModel
  status: 200
}

export type renameSessionApiSessionsSessionIdPatchResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type renameSessionApiSessionsSessionIdPatchResponseSuccess =
  renameSessionApiSessionsSessionIdPatchResponse200 & {
    headers: Headers
  }
export type renameSessionApiSessionsSessionIdPatchResponseError =
  renameSessionApiSessionsSessionIdPatchResponse422 & {
    headers: Headers
  }

export type renameSessionApiSessionsSessionIdPatchResponse =
  | renameSessionApiSessionsSessionIdPatchResponseSuccess
  | renameSessionApiSessionsSessionIdPatchResponseError

export const getRenameSessionApiSessionsSessionIdPatchUrl = (sessionId: string) => {
  return `/api/sessions/${sessionId}`
}

/**
 * Rename a session by updating its title.
 * @summary Rename Session
 */
export const renameSessionApiSessionsSessionIdPatch = async (
  sessionId: string,
  renameSessionRequest: RenameSessionRequest,
  options?: RequestInit
): Promise<renameSessionApiSessionsSessionIdPatchResponse> => {
  return customFetch<renameSessionApiSessionsSessionIdPatchResponse>(
    getRenameSessionApiSessionsSessionIdPatchUrl(sessionId),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(renameSessionRequest),
    }
  )
}

export type deleteSessionApiSessionsSessionIdDeleteResponse204 = {
  data: void
  status: 204
}

export type deleteSessionApiSessionsSessionIdDeleteResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type deleteSessionApiSessionsSessionIdDeleteResponseSuccess =
  deleteSessionApiSessionsSessionIdDeleteResponse204 & {
    headers: Headers
  }
export type deleteSessionApiSessionsSessionIdDeleteResponseError =
  deleteSessionApiSessionsSessionIdDeleteResponse422 & {
    headers: Headers
  }

export type deleteSessionApiSessionsSessionIdDeleteResponse =
  | deleteSessionApiSessionsSessionIdDeleteResponseSuccess
  | deleteSessionApiSessionsSessionIdDeleteResponseError

export const getDeleteSessionApiSessionsSessionIdDeleteUrl = (sessionId: string) => {
  return `/api/sessions/${sessionId}`
}

/**
 * Soft-delete a session by setting deleted_at. The row is not removed.
 * @summary Delete Session
 */
export const deleteSessionApiSessionsSessionIdDelete = async (
  sessionId: string,
  options?: RequestInit
): Promise<deleteSessionApiSessionsSessionIdDeleteResponse> => {
  return customFetch<deleteSessionApiSessionsSessionIdDeleteResponse>(
    getDeleteSessionApiSessionsSessionIdDeleteUrl(sessionId),
    {
      ...options,
      method: 'DELETE',
    }
  )
}

export type suggestTitleApiSessionsSessionIdTitleSuggestPostResponse200 = {
  data: TitleSuggestResponse
  status: 200
}

export type suggestTitleApiSessionsSessionIdTitleSuggestPostResponse401 = {
  data: void
  status: 401
}

export type suggestTitleApiSessionsSessionIdTitleSuggestPostResponse403 = {
  data: void
  status: 403
}

export type suggestTitleApiSessionsSessionIdTitleSuggestPostResponse404 = {
  data: void
  status: 404
}

export type suggestTitleApiSessionsSessionIdTitleSuggestPostResponse422 = {
  data: void
  status: 422
}

export type suggestTitleApiSessionsSessionIdTitleSuggestPostResponse503 = {
  data: void
  status: 503
}

export type suggestTitleApiSessionsSessionIdTitleSuggestPostResponseSuccess =
  suggestTitleApiSessionsSessionIdTitleSuggestPostResponse200 & {
    headers: Headers
  }
export type suggestTitleApiSessionsSessionIdTitleSuggestPostResponseError = (
  | suggestTitleApiSessionsSessionIdTitleSuggestPostResponse401
  | suggestTitleApiSessionsSessionIdTitleSuggestPostResponse403
  | suggestTitleApiSessionsSessionIdTitleSuggestPostResponse404
  | suggestTitleApiSessionsSessionIdTitleSuggestPostResponse422
  | suggestTitleApiSessionsSessionIdTitleSuggestPostResponse503
) & {
  headers: Headers
}

export type suggestTitleApiSessionsSessionIdTitleSuggestPostResponse =
  | suggestTitleApiSessionsSessionIdTitleSuggestPostResponseSuccess
  | suggestTitleApiSessionsSessionIdTitleSuggestPostResponseError

export const getSuggestTitleApiSessionsSessionIdTitleSuggestPostUrl = (sessionId: string) => {
  return `/api/sessions/${sessionId}/title/suggest`
}

/**
 * Generates a short (2–6 word, ≤ 60-char, Title-case) session title via a
lightweight LLM call. PII in the input is never copied to the title.

**Intended usage:** fire this in parallel with `POST /api/chat/stream` — it
does not block the assistant response. Once the title is returned, apply it via
`PATCH /api/sessions/{id}` (the existing rename endpoint).

**Body `message` field:** pass the user's first message text here to avoid a
race condition (the message may not yet be persisted when this is called). If
omitted, the endpoint falls back to reading the first user message from the DB
— this is slower and returns **422** if no message exists yet.

**Error shape** — all 4xx/5xx responses follow the standard shape:
`{"code": "...", "message": "...", "retryable": bool, "request_id": "..."}`.
 * @summary Suggest a session title from the first user message
 */
export const suggestTitleApiSessionsSessionIdTitleSuggestPost = async (
  sessionId: string,
  titleSuggestRequest: TitleSuggestRequest,
  options?: RequestInit
): Promise<suggestTitleApiSessionsSessionIdTitleSuggestPostResponse> => {
  return customFetch<suggestTitleApiSessionsSessionIdTitleSuggestPostResponse>(
    getSuggestTitleApiSessionsSessionIdTitleSuggestPostUrl(sessionId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(titleSuggestRequest),
    }
  )
}

export type togglePinApiSessionsSessionIdPinPostResponse200 = {
  data: SessionModel
  status: 200
}

export type togglePinApiSessionsSessionIdPinPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type togglePinApiSessionsSessionIdPinPostResponseSuccess =
  togglePinApiSessionsSessionIdPinPostResponse200 & {
    headers: Headers
  }
export type togglePinApiSessionsSessionIdPinPostResponseError =
  togglePinApiSessionsSessionIdPinPostResponse422 & {
    headers: Headers
  }

export type togglePinApiSessionsSessionIdPinPostResponse =
  | togglePinApiSessionsSessionIdPinPostResponseSuccess
  | togglePinApiSessionsSessionIdPinPostResponseError

export const getTogglePinApiSessionsSessionIdPinPostUrl = (sessionId: string) => {
  return `/api/sessions/${sessionId}/pin`
}

/**
 * Toggle the pinned state of a session.
 * @summary Toggle Pin
 */
export const togglePinApiSessionsSessionIdPinPost = async (
  sessionId: string,
  options?: RequestInit
): Promise<togglePinApiSessionsSessionIdPinPostResponse> => {
  return customFetch<togglePinApiSessionsSessionIdPinPostResponse>(
    getTogglePinApiSessionsSessionIdPinPostUrl(sessionId),
    {
      ...options,
      method: 'POST',
    }
  )
}

export type postFeedbackApiSessionsSessionIdMessagesMessageIdFeedbackPostResponse200 = {
  data: FeedbackResponse
  status: 200
}

export type postFeedbackApiSessionsSessionIdMessagesMessageIdFeedbackPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type postFeedbackApiSessionsSessionIdMessagesMessageIdFeedbackPostResponseSuccess =
  postFeedbackApiSessionsSessionIdMessagesMessageIdFeedbackPostResponse200 & {
    headers: Headers
  }
export type postFeedbackApiSessionsSessionIdMessagesMessageIdFeedbackPostResponseError =
  postFeedbackApiSessionsSessionIdMessagesMessageIdFeedbackPostResponse422 & {
    headers: Headers
  }

export type postFeedbackApiSessionsSessionIdMessagesMessageIdFeedbackPostResponse =
  | postFeedbackApiSessionsSessionIdMessagesMessageIdFeedbackPostResponseSuccess
  | postFeedbackApiSessionsSessionIdMessagesMessageIdFeedbackPostResponseError

export const getPostFeedbackApiSessionsSessionIdMessagesMessageIdFeedbackPostUrl = (
  sessionId: string,
  messageId: string
) => {
  return `/api/sessions/${sessionId}/messages/${messageId}/feedback`
}

/**
 * Record feedback on a specific message within a session.
 * @summary Post Feedback
 */
export const postFeedbackApiSessionsSessionIdMessagesMessageIdFeedbackPost = async (
  sessionId: string,
  messageId: string,
  feedbackRequest: FeedbackRequest,
  options?: RequestInit
): Promise<postFeedbackApiSessionsSessionIdMessagesMessageIdFeedbackPostResponse> => {
  return customFetch<postFeedbackApiSessionsSessionIdMessagesMessageIdFeedbackPostResponse>(
    getPostFeedbackApiSessionsSessionIdMessagesMessageIdFeedbackPostUrl(sessionId, messageId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(feedbackRequest),
    }
  )
}

export type editMessageApiSessionsSessionIdMessagesMessageIdPatchResponse200 = {
  data: unknown
  status: 200
}

export type editMessageApiSessionsSessionIdMessagesMessageIdPatchResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type editMessageApiSessionsSessionIdMessagesMessageIdPatchResponseSuccess =
  editMessageApiSessionsSessionIdMessagesMessageIdPatchResponse200 & {
    headers: Headers
  }
export type editMessageApiSessionsSessionIdMessagesMessageIdPatchResponseError =
  editMessageApiSessionsSessionIdMessagesMessageIdPatchResponse422 & {
    headers: Headers
  }

export type editMessageApiSessionsSessionIdMessagesMessageIdPatchResponse =
  | editMessageApiSessionsSessionIdMessagesMessageIdPatchResponseSuccess
  | editMessageApiSessionsSessionIdMessagesMessageIdPatchResponseError

export const getEditMessageApiSessionsSessionIdMessagesMessageIdPatchUrl = (
  sessionId: string,
  messageId: string
) => {
  return `/api/sessions/${sessionId}/messages/${messageId}`
}

/**
 * Edit a user message, soft-supersede downstream messages, and stream a fresh response.

Auth and ownership are checked before any SSE bytes are written so
unauthenticated / forbidden requests get a normal 401/403/404 response.
Once the stream starts, failures are surfaced as ``event: error``.
 * @summary Edit Message
 */
export const editMessageApiSessionsSessionIdMessagesMessageIdPatch = async (
  sessionId: string,
  messageId: string,
  editMessageRequest: EditMessageRequest,
  options?: RequestInit
): Promise<editMessageApiSessionsSessionIdMessagesMessageIdPatchResponse> => {
  return customFetch<editMessageApiSessionsSessionIdMessagesMessageIdPatchResponse>(
    getEditMessageApiSessionsSessionIdMessagesMessageIdPatchUrl(sessionId, messageId),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(editMessageRequest),
    }
  )
}

export type shareSessionApiSessionsSessionIdSharePostResponse200 = {
  data: ShareSessionResponse
  status: 200
}

export type shareSessionApiSessionsSessionIdSharePostResponse403 = {
  data: void
  status: 403
}

export type shareSessionApiSessionsSessionIdSharePostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type shareSessionApiSessionsSessionIdSharePostResponseSuccess =
  shareSessionApiSessionsSessionIdSharePostResponse200 & {
    headers: Headers
  }
export type shareSessionApiSessionsSessionIdSharePostResponseError = (
  | shareSessionApiSessionsSessionIdSharePostResponse403
  | shareSessionApiSessionsSessionIdSharePostResponse422
) & {
  headers: Headers
}

export type shareSessionApiSessionsSessionIdSharePostResponse =
  | shareSessionApiSessionsSessionIdSharePostResponseSuccess
  | shareSessionApiSessionsSessionIdSharePostResponseError

export const getShareSessionApiSessionsSessionIdSharePostUrl = (sessionId: string) => {
  return `/api/sessions/${sessionId}/share`
}

/**
 * Create a share link for a session — a paid-only feature.

Verifies ownership (404/403) and then that the member's entitlement unlocks share
links; otherwise raises ``FEATURE_NOT_AVAILABLE`` (403). Existing public
``GET /api/shared/{token}`` links stay readable after a downgrade.
 * @summary Share Session
 */
export const shareSessionApiSessionsSessionIdSharePost = async (
  sessionId: string,
  options?: RequestInit
): Promise<shareSessionApiSessionsSessionIdSharePostResponse> => {
  return customFetch<shareSessionApiSessionsSessionIdSharePostResponse>(
    getShareSessionApiSessionsSessionIdSharePostUrl(sessionId),
    {
      ...options,
      method: 'POST',
    }
  )
}

export type getShareApiSessionsSessionIdShareGetResponse200 = {
  data: ShareSessionResponse
  status: 200
}

export type getShareApiSessionsSessionIdShareGetResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getShareApiSessionsSessionIdShareGetResponseSuccess =
  getShareApiSessionsSessionIdShareGetResponse200 & {
    headers: Headers
  }
export type getShareApiSessionsSessionIdShareGetResponseError =
  getShareApiSessionsSessionIdShareGetResponse422 & {
    headers: Headers
  }

export type getShareApiSessionsSessionIdShareGetResponse =
  | getShareApiSessionsSessionIdShareGetResponseSuccess
  | getShareApiSessionsSessionIdShareGetResponseError

export const getGetShareApiSessionsSessionIdShareGetUrl = (sessionId: string) => {
  return `/api/sessions/${sessionId}/share`
}

/**
 * Return the active share link for a session, or 404 if none exists.
 * @summary Get Share
 */
export const getShareApiSessionsSessionIdShareGet = async (
  sessionId: string,
  options?: RequestInit
): Promise<getShareApiSessionsSessionIdShareGetResponse> => {
  return customFetch<getShareApiSessionsSessionIdShareGetResponse>(
    getGetShareApiSessionsSessionIdShareGetUrl(sessionId),
    {
      ...options,
      method: 'GET',
    }
  )
}

export type revokeShareApiSessionsSessionIdShareDeleteResponse204 = {
  data: void
  status: 204
}

export type revokeShareApiSessionsSessionIdShareDeleteResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type revokeShareApiSessionsSessionIdShareDeleteResponseSuccess =
  revokeShareApiSessionsSessionIdShareDeleteResponse204 & {
    headers: Headers
  }
export type revokeShareApiSessionsSessionIdShareDeleteResponseError =
  revokeShareApiSessionsSessionIdShareDeleteResponse422 & {
    headers: Headers
  }

export type revokeShareApiSessionsSessionIdShareDeleteResponse =
  | revokeShareApiSessionsSessionIdShareDeleteResponseSuccess
  | revokeShareApiSessionsSessionIdShareDeleteResponseError

export const getRevokeShareApiSessionsSessionIdShareDeleteUrl = (sessionId: string) => {
  return `/api/sessions/${sessionId}/share`
}

/**
 * Revoke the active share link. Subsequent GET /api/shared/{token} return 410.
 * @summary Revoke Share
 */
export const revokeShareApiSessionsSessionIdShareDelete = async (
  sessionId: string,
  options?: RequestInit
): Promise<revokeShareApiSessionsSessionIdShareDeleteResponse> => {
  return customFetch<revokeShareApiSessionsSessionIdShareDeleteResponse>(
    getRevokeShareApiSessionsSessionIdShareDeleteUrl(sessionId),
    {
      ...options,
      method: 'DELETE',
    }
  )
}

export type regenerateMessageApiSessionsSessionIdMessagesMessageIdRegeneratePostResponse200 = {
  data: unknown
  status: 200
}

export type regenerateMessageApiSessionsSessionIdMessagesMessageIdRegeneratePostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type regenerateMessageApiSessionsSessionIdMessagesMessageIdRegeneratePostResponseSuccess =
  regenerateMessageApiSessionsSessionIdMessagesMessageIdRegeneratePostResponse200 & {
    headers: Headers
  }
export type regenerateMessageApiSessionsSessionIdMessagesMessageIdRegeneratePostResponseError =
  regenerateMessageApiSessionsSessionIdMessagesMessageIdRegeneratePostResponse422 & {
    headers: Headers
  }

export type regenerateMessageApiSessionsSessionIdMessagesMessageIdRegeneratePostResponse =
  | regenerateMessageApiSessionsSessionIdMessagesMessageIdRegeneratePostResponseSuccess
  | regenerateMessageApiSessionsSessionIdMessagesMessageIdRegeneratePostResponseError

export const getRegenerateMessageApiSessionsSessionIdMessagesMessageIdRegeneratePostUrl = (
  sessionId: string,
  messageId: string
) => {
  return `/api/sessions/${sessionId}/messages/${messageId}/regenerate`
}

/**
 * @summary Regenerate Message
 */
export const regenerateMessageApiSessionsSessionIdMessagesMessageIdRegeneratePost = async (
  sessionId: string,
  messageId: string,
  options?: RequestInit
): Promise<regenerateMessageApiSessionsSessionIdMessagesMessageIdRegeneratePostResponse> => {
  return customFetch<regenerateMessageApiSessionsSessionIdMessagesMessageIdRegeneratePostResponse>(
    getRegenerateMessageApiSessionsSessionIdMessagesMessageIdRegeneratePostUrl(
      sessionId,
      messageId
    ),
    {
      ...options,
      method: 'POST',
    }
  )
}

export type healthCheckApiHealthGetResponse200 = {
  data: unknown
  status: 200
}

export type healthCheckApiHealthGetResponseSuccess = healthCheckApiHealthGetResponse200 & {
  headers: Headers
}
export type healthCheckApiHealthGetResponse = healthCheckApiHealthGetResponseSuccess

export const getHealthCheckApiHealthGetUrl = () => {
  return `/api/health/`
}

/**
 * Readiness — probe every hard dependency concurrently.
 * @summary Health Check
 */
export const healthCheckApiHealthGet = async (
  options?: RequestInit
): Promise<healthCheckApiHealthGetResponse> => {
  return customFetch<healthCheckApiHealthGetResponse>(getHealthCheckApiHealthGetUrl(), {
    ...options,
    method: 'GET',
  })
}

export type livenessApiHealthLiveGetResponse200 = {
  data: unknown
  status: 200
}

export type livenessApiHealthLiveGetResponseSuccess = livenessApiHealthLiveGetResponse200 & {
  headers: Headers
}
export type livenessApiHealthLiveGetResponse = livenessApiHealthLiveGetResponseSuccess

export const getLivenessApiHealthLiveGetUrl = () => {
  return `/api/health/live`
}

/**
 * Liveness — process is serving; no dependency checks.
 * @summary Liveness
 */
export const livenessApiHealthLiveGet = async (
  options?: RequestInit
): Promise<livenessApiHealthLiveGetResponse> => {
  return customFetch<livenessApiHealthLiveGetResponse>(getLivenessApiHealthLiveGetUrl(), {
    ...options,
    method: 'GET',
  })
}

export type getFeaturedPromptsApiPromptsGetResponse200 = {
  data: PromptResponse[]
  status: 200
}

export type getFeaturedPromptsApiPromptsGetResponseSuccess =
  getFeaturedPromptsApiPromptsGetResponse200 & {
    headers: Headers
  }
export type getFeaturedPromptsApiPromptsGetResponse = getFeaturedPromptsApiPromptsGetResponseSuccess

export const getGetFeaturedPromptsApiPromptsGetUrl = () => {
  return `/api/prompts`
}

/**
 * @summary Get Featured Prompts
 */
export const getFeaturedPromptsApiPromptsGet = async (
  options?: RequestInit
): Promise<getFeaturedPromptsApiPromptsGetResponse> => {
  return customFetch<getFeaturedPromptsApiPromptsGetResponse>(
    getGetFeaturedPromptsApiPromptsGetUrl(),
    {
      ...options,
      method: 'GET',
    }
  )
}

export type getMeApiUsersMeGetResponse200 = {
  data: UserResponse
  status: 200
}

export type getMeApiUsersMeGetResponseSuccess = getMeApiUsersMeGetResponse200 & {
  headers: Headers
}
export type getMeApiUsersMeGetResponse = getMeApiUsersMeGetResponseSuccess

export const getGetMeApiUsersMeGetUrl = () => {
  return `/api/users/me`
}

/**
 * Return the authenticated user's profile including membership tier.
 * @summary Get Me
 */
export const getMeApiUsersMeGet = async (
  options?: RequestInit
): Promise<getMeApiUsersMeGetResponse> => {
  return customFetch<getMeApiUsersMeGetResponse>(getGetMeApiUsersMeGetUrl(), {
    ...options,
    method: 'GET',
  })
}

export type updateDisplayNameApiUsersDisplayNamePatchResponse200 = {
  data: UserResponse
  status: 200
}

export type updateDisplayNameApiUsersDisplayNamePatchResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type updateDisplayNameApiUsersDisplayNamePatchResponseSuccess =
  updateDisplayNameApiUsersDisplayNamePatchResponse200 & {
    headers: Headers
  }
export type updateDisplayNameApiUsersDisplayNamePatchResponseError =
  updateDisplayNameApiUsersDisplayNamePatchResponse422 & {
    headers: Headers
  }

export type updateDisplayNameApiUsersDisplayNamePatchResponse =
  | updateDisplayNameApiUsersDisplayNamePatchResponseSuccess
  | updateDisplayNameApiUsersDisplayNamePatchResponseError

export const getUpdateDisplayNameApiUsersDisplayNamePatchUrl = () => {
  return `/api/users/display-name`
}

/**
 * Update the authenticated user's display name.
 * @summary Update Display Name
 */
export const updateDisplayNameApiUsersDisplayNamePatch = async (
  updateDisplayNameRequest: UpdateDisplayNameRequest,
  options?: RequestInit
): Promise<updateDisplayNameApiUsersDisplayNamePatchResponse> => {
  return customFetch<updateDisplayNameApiUsersDisplayNamePatchResponse>(
    getUpdateDisplayNameApiUsersDisplayNamePatchUrl(),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateDisplayNameRequest),
    }
  )
}

export type createCheckoutSessionApiBillingCheckoutSessionsPostResponse200 = {
  data: CheckoutSessionResponse
  status: 200
}

export type createCheckoutSessionApiBillingCheckoutSessionsPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createCheckoutSessionApiBillingCheckoutSessionsPostResponseSuccess =
  createCheckoutSessionApiBillingCheckoutSessionsPostResponse200 & {
    headers: Headers
  }
export type createCheckoutSessionApiBillingCheckoutSessionsPostResponseError =
  createCheckoutSessionApiBillingCheckoutSessionsPostResponse422 & {
    headers: Headers
  }

export type createCheckoutSessionApiBillingCheckoutSessionsPostResponse =
  | createCheckoutSessionApiBillingCheckoutSessionsPostResponseSuccess
  | createCheckoutSessionApiBillingCheckoutSessionsPostResponseError

export const getCreateCheckoutSessionApiBillingCheckoutSessionsPostUrl = () => {
  return `/api/billing/checkout-sessions`
}

/**
 * @summary Create Checkout Session
 */
export const createCheckoutSessionApiBillingCheckoutSessionsPost = async (
  checkoutSessionRequest: CheckoutSessionRequest,
  options?: RequestInit
): Promise<createCheckoutSessionApiBillingCheckoutSessionsPostResponse> => {
  return customFetch<createCheckoutSessionApiBillingCheckoutSessionsPostResponse>(
    getCreateCheckoutSessionApiBillingCheckoutSessionsPostUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(checkoutSessionRequest),
    }
  )
}

export type createPortalSessionApiBillingPortalSessionsPostResponse200 = {
  data: PortalSessionResponse
  status: 200
}

export type createPortalSessionApiBillingPortalSessionsPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createPortalSessionApiBillingPortalSessionsPostResponseSuccess =
  createPortalSessionApiBillingPortalSessionsPostResponse200 & {
    headers: Headers
  }
export type createPortalSessionApiBillingPortalSessionsPostResponseError =
  createPortalSessionApiBillingPortalSessionsPostResponse422 & {
    headers: Headers
  }

export type createPortalSessionApiBillingPortalSessionsPostResponse =
  | createPortalSessionApiBillingPortalSessionsPostResponseSuccess
  | createPortalSessionApiBillingPortalSessionsPostResponseError

export const getCreatePortalSessionApiBillingPortalSessionsPostUrl = () => {
  return `/api/billing/portal-sessions`
}

/**
 * @summary Create Portal Session
 */
export const createPortalSessionApiBillingPortalSessionsPost = async (
  portalSessionRequest: PortalSessionRequest,
  options?: RequestInit
): Promise<createPortalSessionApiBillingPortalSessionsPostResponse> => {
  return customFetch<createPortalSessionApiBillingPortalSessionsPostResponse>(
    getCreatePortalSessionApiBillingPortalSessionsPostUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(portalSessionRequest),
    }
  )
}

export type stripeWebhookApiStripeWebhookPostResponse200 = {
  data: StripeWebhookApiStripeWebhookPost200
  status: 200
}

export type stripeWebhookApiStripeWebhookPostResponseSuccess =
  stripeWebhookApiStripeWebhookPostResponse200 & {
    headers: Headers
  }
export type stripeWebhookApiStripeWebhookPostResponse =
  stripeWebhookApiStripeWebhookPostResponseSuccess

export const getStripeWebhookApiStripeWebhookPostUrl = () => {
  return `/api/stripe/webhook`
}

/**
 * @summary Stripe Webhook
 */
export const stripeWebhookApiStripeWebhookPost = async (
  options?: RequestInit
): Promise<stripeWebhookApiStripeWebhookPostResponse> => {
  return customFetch<stripeWebhookApiStripeWebhookPostResponse>(
    getStripeWebhookApiStripeWebhookPostUrl(),
    {
      ...options,
      method: 'POST',
    }
  )
}

export type getSharedSessionApiSharedShareTokenGetResponse200 = {
  data: SharedSessionResponse
  status: 200
}

export type getSharedSessionApiSharedShareTokenGetResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getSharedSessionApiSharedShareTokenGetResponseSuccess =
  getSharedSessionApiSharedShareTokenGetResponse200 & {
    headers: Headers
  }
export type getSharedSessionApiSharedShareTokenGetResponseError =
  getSharedSessionApiSharedShareTokenGetResponse422 & {
    headers: Headers
  }

export type getSharedSessionApiSharedShareTokenGetResponse =
  | getSharedSessionApiSharedShareTokenGetResponseSuccess
  | getSharedSessionApiSharedShareTokenGetResponseError

export const getGetSharedSessionApiSharedShareTokenGetUrl = (shareToken: string) => {
  return `/api/shared/${shareToken}`
}

/**
 * Fetch a shared session by token — no auth required.
 * @summary Get Shared Session
 */
export const getSharedSessionApiSharedShareTokenGet = async (
  shareToken: string,
  options?: RequestInit
): Promise<getSharedSessionApiSharedShareTokenGetResponse> => {
  return customFetch<getSharedSessionApiSharedShareTokenGetResponse>(
    getGetSharedSessionApiSharedShareTokenGetUrl(shareToken),
    {
      ...options,
      method: 'GET',
    }
  )
}

export type reportBugApiFeedbackPostResponse201 = {
  data: BugReportResponse
  status: 201
}

export type reportBugApiFeedbackPostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type reportBugApiFeedbackPostResponseSuccess = reportBugApiFeedbackPostResponse201 & {
  headers: Headers
}
export type reportBugApiFeedbackPostResponseError = reportBugApiFeedbackPostResponse422 & {
  headers: Headers
}

export type reportBugApiFeedbackPostResponse =
  | reportBugApiFeedbackPostResponseSuccess
  | reportBugApiFeedbackPostResponseError

export const getReportBugApiFeedbackPostUrl = () => {
  return `/api/feedback`
}

/**
 * Submit a bug report. The report is saved and linked to the authenticated user.
 * @summary Report Bug
 */
export const reportBugApiFeedbackPost = async (
  bugReportRequest: BugReportRequest,
  options?: RequestInit
): Promise<reportBugApiFeedbackPostResponse> => {
  return customFetch<reportBugApiFeedbackPostResponse>(getReportBugApiFeedbackPostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bugReportRequest),
  })
}

export type getDisclaimerApiDisclaimerGetResponse200 = {
  data: DisclaimerResponse
  status: 200
}

export type getDisclaimerApiDisclaimerGetResponse401 = {
  data: void
  status: 401
}

export type getDisclaimerApiDisclaimerGetResponseSuccess =
  getDisclaimerApiDisclaimerGetResponse200 & {
    headers: Headers
  }
export type getDisclaimerApiDisclaimerGetResponseError =
  getDisclaimerApiDisclaimerGetResponse401 & {
    headers: Headers
  }

export type getDisclaimerApiDisclaimerGetResponse =
  | getDisclaimerApiDisclaimerGetResponseSuccess
  | getDisclaimerApiDisclaimerGetResponseError

export const getGetDisclaimerApiDisclaimerGetUrl = () => {
  return `/api/disclaimer`
}

/**
 * Returns the disclaimer and terms copy for the mobile app's post-login disclaimer screen. Requires a valid authenticated session. Content is managed server-side and can be updated without a mobile release.
 * @summary Get disclaimer and terms content
 */
export const getDisclaimerApiDisclaimerGet = async (
  options?: RequestInit
): Promise<getDisclaimerApiDisclaimerGetResponse> => {
  return customFetch<getDisclaimerApiDisclaimerGetResponse>(getGetDisclaimerApiDisclaimerGetUrl(), {
    ...options,
    method: 'GET',
  })
}
